import { Scanner, IDetectedBarcode } from "@yudiel/react-qr-scanner";

interface QRCodeReaderProps {
  paused?: boolean;
  onScan?: (codes: IDetectedBarcode[]) => void;
}

export default function QRCodeReader({
  paused = false,
  onScan = () => {},
}: QRCodeReaderProps) {
  return (
    <Scanner
      paused={paused}
      constraints={{ facingMode: "environment" }}
      onScan={onScan}
      onError={(err) => console.debug(err)}
      components={{ finder: false }}
    />
  );
}
